export class DarkSwapError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DarkSwapError';
  }
}
